import React from 'react';
import styled from 'styled-components';
import { COLOR, mobile } from '../../../styles/variables';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export const FoldableLayout = styled.section<{ isResponsive?: boolean }>`
    background-color: ${({ isResponsive }) => (isResponsive ? 'transparent' : COLOR.br24.lightGrey)};
    font-size: 1rem;
    padding: 0 2rem;
    font-family: Standard;
    font-weight: normal;
    width: 100%;
    height: auto;
`;

export const Trigger = styled.button<{ showDivider?: boolean; isResponsive?: boolean }>`
    outline: none;
    border: none;
    box-shadow: none;
    width: 100%;
    height: 3.5rem;
    margin: 0;
    background: none;
    display: flex;
    padding: 0;
    align-items: center;

    @media ${mobile} {
        border-bottom: ${({ showDivider }) => (showDivider ? '1px solid white' : 'none')};
    }
`;

export const TriggerText = styled.div<{ isResponsive?: boolean }>`
    margin-left: ${({ isResponsive }) => (isResponsive ? 0 : 'auto')};
    color: ${COLOR.br24.darkBlueGrey};

    > * {
        margin-bottom: 0 !important;
        margin-top: 0 !important;
    }
`;

export const Content = styled.div<{ isOpen?: boolean; height?: number; isResponsive?: boolean }>`
    max-height: ${({ isOpen, height = 100, isResponsive }) => (isResponsive ? 'unset' : isOpen ? `${height}px` : 0)};
    overflow: hidden;
    transition: max-height 0.25s ease-out;

    @media ${mobile} {
        max-height: ${({ isOpen, height = 100 }) => (isOpen ? `${height}px` : 0)};
    }
`;

export const Inner = styled.div`
    padding-bottom: 10px;
`;

export const TriggerIcon = styled(
    ({
        open,
        responsive,
        ...props
    }: FontAwesomeIconProps & {
        open?: boolean;
        responsive: boolean;
    }) => <FontAwesomeIcon {...props} />
)<{
    open?: boolean;
    responsive: boolean;
}>`
    transform: ${({ open }) => (open ? `rotate(-180deg)` : `rotate(0)`)};
    transition: transform 0.25s ease-out;
    font-size: 1.25rem;
    color: ${COLOR.br24.mediumGrey};
    margin-left: ${({ responsive }) => (!responsive ? 0 : 'auto')};
    display: ${({ responsive }) => (responsive ? 'none' : 'block')};

    @media ${mobile} {
        display: block;
    }
`;
